// What a failed members call tells the user: the backend's own message (it
// says which product or role was refused, or why the owner cannot go), else a
// fallback. emailTaken is for create and invite only, where a 409 means the
// email already has a login; elsewhere a 409 is whatever the backend says.
export const memberErrorMessage = (error: any, fallback: string, { emailTaken = false } = {}): string => {
    if (emailTaken && error?.response?.status === 409) {
        return 'A user with this email already exists.';
    }
    return error?.response?.data?.error || error?.response?.data?.message || fallback;
};
